<template>
  <div>
    <template>
      <CContainer>
        <CModal
          title="Confirmar que quieres eliminar el quiz  quizSelected"
          color="danger"
          :show.sync="confirmar"
          class="text-center"
          style="top: 40px"
          @close="confirmar = false"
        >
          <mdbModalHeader center :close="false" slot="header">
            <p class="heading">
              Confirmar que quieres eliminar el quiz {{ quizSelected.name }}
            </p>
          </mdbModalHeader>
          <mdbModalFooter center slot="footer">
            <CButton outline="danger" @click="eliminar()">Si</CButton>
            <CButton color="danger" @click="confirmar = false">No</CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>
    </template>
    <!-- <template>
      <mdb-container>
        <mdb-modal
          :show="confirmar"
          @close="confirmar = false"
          size="sm"
          class="text-center"
          style="top:40px;"
          danger
        >
          <mdb-modal-header center :close="false">
            <p class="heading">Confirmar que quieres eliminar el quiz {{quizSelected.name}}</p>
          </mdb-modal-header>
          <mdb-modal-body>
            <mdb-icon icon="times" size="4x" class="animated rotateIn" />
          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="eliminar()">Si</mdb-btn>
            <mdb-btn color="danger" @click="confirmar = false">No</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </mdb-container>
    </template>-->

    <template>
      <CContainer>
        <CModal
          title="FTP"
          color="danger"
          :show.sync="sendFtp"
          class="text-center"
          style="top: 40px"
          @close="confirmar = false"
        >
          <mdbModalHeader center :close="false">
            <p class="heading">Se ha publicado el Ftp con exito.</p>
          </mdbModalHeader>

          <mdbModalFooter center slot="footer">
            <CButton color="danger" @click="sendFtp = false">Ok</CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>
    </template>

    <div>
      <CCard>
        <CCardHeader>
          <slot name="header">
            <i class="fas fa-images mr-2"></i>
            {{ caption }}
            <div class="text-right" v-if="type_show === 'table'">
              <CButton @click="changeView('card')">
                Card View
                <i class="fas fa-images"></i>
              </CButton>
            </div>
            <div class="text-right" v-else>
              <CButton @click="changeView('table')">
                Table View
                <i class="fa fa-table"></i>
              </CButton>
            </div>
          </slot>
        </CCardHeader>
        <CCardBody>
          <modals-container v-model="items" />
          <div>
            <template>
              <CContainer>
                <CModal
                  title="FTP"
                  color="primary"
                  :show.sync="modal"
                  class="text-center"
                  style="top: 40px"
                  @close="confirmar = false"
                  size="xl"
                >
                  <mdbModalHeader center :close="false" slot="header">
                    <p class="heading">{{ modalName }}</p>
                  </mdbModalHeader>

                  <mdbModalBody class="modal-body">
                    <Modal-create-quiz
                      :onClick="closeModalCreate"
                      v-if="modalName == 'Crear'"
                    ></Modal-create-quiz>
                    <Modal-edit-quiz
                      :onClick="closeModalCreate"
                      :webSite="quizSelected"
                      v-if="modalName == 'Editar'"
                    ></Modal-edit-quiz>
                  </mdbModalBody>

                  <!--  <modal-create-quiz :onClick="closeModalCreate" v-if="modalName=='Crear'"></modal-create-quiz>
                    <modal-edit-quiz
                      :onClick="closeModalCreate"
                      :webSite="quizSelected"
                      v-if="modalName=='Editar'"
                    ></modal-edit-quiz>
                  -->
                  <mdbModalFooter center slot="footer">
                    <CButton color="danger" @click="modal = false"
                      >Cancelar</CButton
                    >
                  </mdbModalFooter>
                </CModal>
              </CContainer>
            </template>
          </div>

          <div v-if="type_show === 'table'">
            <CDataTable
              responsive
              hover
              striped
              bordered
              small
              fixed
              :items="itemQuiz"
              :fields="fields"
              :dark="dark"
              :items-per-page="10"
              column-filter
              sorter
              pagination
            >
              <template slot="domain_id" slot-scope="data">
                <CCol>{{ data.item.domain_id.name }}</CCol>
              </template>

              <template slot="acciones" slot-scope="data">
                <CCol>
                  <CNav>
                    <CDropdown placement="bottom-end" toggler-text="Acciones">
                      <CDropdownItem>
                        <router-link
                          class="toggler-text"
                          :to="{ name: 'EditQuiz', params: { webSite: item } }"
                          >Editar</router-link
                        >
                      </CDropdownItem>
                      <CDropdownItem @click="selectQuizDelete(data.item)"
                        >Eliminar</CDropdownItem
                      >
                      <CDropdownItem @click="redirectToCreatePage(item.id)"
                        >Duplicar</CDropdownItem
                      >
                      <CDropdownDivider />
                      <CDropdownItem @click="publicarFtp(data.item.id)"
                        >Publicar en FTP</CDropdownItem
                      >
                      <CDropdownItem @click="quizPreview(data.item.id)"
                        >Quiz preview</CDropdownItem
                      >
                      <CDropdownItem @click="redirectToanswerTab(item.id)"
                        >ver stats</CDropdownItem
                      >
                    </CDropdown>
                  </CNav>
                </CCol>
              </template>
            </CDataTable>
          </div>

          <div v-else>
            <CCard class="p-3">
              <CCardHeader>
                <CCardTitle>
                  <i class="cil-library mr-3"></i>Surveys
                </CCardTitle>
                <CRow class="pt-2 survey-wrapper">
                  <CCol sm="4">
                    <!-- <CSelect :options="searchDropdownPartner_id" /> -->
                    <multiselect
                      v-model="selectedPartnerId"
                      placeholder="Seleccione un Partner"
                      label="value"
                      track-by="id"
                      :options="partners"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :multiple="false"
                      :taggable="false"
                    ></multiselect>
                    <!-- @input="onChangePartnerId()" -->

                    <!-- <select
                      style="height:40px; width:300px; marginLeft:-20"
                      v-model="selectedPartnerId"
                      v-on:change="onChangePartnerId(selectedPartnerId)"
                    >
                      <option
                        v-for="(option,key) in partnerFilter"
                        :key="key"
                        v-bind:value="option.id"
                      >{{ option }}</option>
                    </select>-->
                  </CCol>
                  <CCol sm="4">
                    <!-- <CSelect :options="searchDropdownName" /> -->
                    <multiselect
                      v-model="selectedName"
                      placeholder="Seleccione un Survey"
                      label="name"
                      track-by="id"
                      :options="surveys_temp"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :multiple="false"
                      :taggable="true"
                      @input="onChangeName()"
                    ></multiselect>

                    <!-- <select
                      style="height:40px; width:300px"
                      v-model="selectedName"
                      v-on:change="onChangeName(selectedName)"
                    >
                      <option
                        v-for="(option,key) in searchDropdownName"
                        :key="key"
                        v-bind:value="option"
                      >{{ option}}</option>
                    </select>-->
                  </CCol>
                  <CCol sm="4">
                    <!-- <CSelect :options="searchDropdownDate" /> -->
                    <CBadge color="light" class="float-right p-1">
                      <CDropdown color=" p-0" placement="bottom-end">
                        <template #toggler-content>
                          <i
                            class="fa fa-sort-amount-asc"
                            aria-hidden="true"
                          ></i>
                          <!-- <CIcon name="cil-settings" /> -->
                        </template>
                        <CDropdownItem
                          @click.native="getSortedquiz('createDateAsc')"
                        >
                          createDate
                          <i
                            class="fa fa-sort-amount-asc ml-2"
                            aria-hidden="true"
                          ></i>
                        </CDropdownItem>
                        <CDropdownItem
                          @click.native="getSortedquiz('createDateDesc')"
                        >
                          createDate
                          <i
                            class="fa fa-sort-amount-desc ml-2"
                            aria-hidden="true"
                          ></i>
                        </CDropdownItem>
                        <CDropdownItem
                          @click.native="getSortedquiz('stat_idAsc')"
                          >No of stat_ids
                          <i
                            class="fa fa-sort-alpha-asc ml-2"
                            aria-hidden="true"
                          ></i
                        ></CDropdownItem>
                        <CDropdownItem
                          @click.native="getSortedquiz('stat_idDesc')"
                          >No of stat_ids
                          <i
                            class="fa fa-sort-alpha-desc ml-2"
                            aria-hidden="true"
                          ></i
                        ></CDropdownItem>
                      </CDropdown>
                    </CBadge>
                  </CCol>
                </CRow>
              </CCardHeader>

              <div v-if="isLoading_quiz">
                <semipolar-spinner
                  :animation-duration="2000"
                  :size="80"
                  color="blue"
                ></semipolar-spinner>
              </div>
              <div v-else>
                <CRow class="mt-3">
                  <!-- <div  class="col-md-3" v-for="item in pageOfItems" :key="item.id"> -->
                  <CCol
                    lg="3"
                    class="partner-card"
                    v-for="item in pageOfItems"
                    :key="item.id"
                  >
                    <CCard class="shadow mb-5 bg-white rounded">
                      <!-- <img src="../../../public/img/Apache_logo.png" alt="..."  class="card-img" /> -->

                      <CCardBody class="box p-0" backgroupcolor="light">
                        <!-- :style="{
                      backgroundImage: `url(${getimage(item.title_img[0])})`
                      
                   }" -->
                        <CImg
                          :src="getimage(item.title_img[0])"
                          class="p-0 card-img"
                        />
                        <!-- <CImg
                  style="width: 80%;"
                  src="img/marca.png"
                  class="p-0"
                  
                />  -->

                        <!-- backgroundImage: `url(${item.title_img.image_url -->
                      </CCardBody>
                      <span class="text-center p-3"
                        ><strong>{{ item.display_name }}</strong></span
                      >
                      <!-- </div>
                    >{{item.name}}</CCardBody>-->
                      <CCardFooter align="right">
                        <CRow>
                          <!-- <CCardBody color="light" align="center" class="">Respuestes</CCardBody> -->

                          <CCardText
                            class="shadow-none p-2 bg-light rounded ml-4"
                            >{{ getcomments(item.id) }} respuestas</CCardText
                          >
                          <!-- <CIcon name="cil-options" /> -->
                          <CDropdown toggler-text class="ml-3">
                            <CDropdownItem @click="quizPreview(item.id)"
                              >preview</CDropdownItem
                            >
                            <!-- <CDropdownItem @click="selectQuizEdit(item,pageOfItems)">Editar</CDropdownItem> -->
                            <!-- <CDropdownItem @click="redirectToEditPage(item)">Editar</CDropdownItem> -->
                            <CDropdownItem>
                              <router-link
                                class="toggler-text"
                                :to="{
                                  name: 'EditQuiz',
                                  params: { webSite: item },
                                }"
                                >Editar</router-link
                              >
                            </CDropdownItem>
                            <!-- <CDropdownItem @click="redirectToCreatePage(item.id)">Duplicar</CDropdownItem> -->
                            <CDropdownItem>
                              <router-link
                                class="toggler-text"
                                :to="{
                                  name: 'DuplicateQuiz',
                                  params: { webSite: item },
                                }"
                                >Duplicar</router-link
                              >
                            </CDropdownItem>
                            <CDropdownDivider />
                            <CDropdownItem @click="publicarFtp(item.id)"
                              >Publicar en FTP</CDropdownItem
                            >
                            <CDropdownItem @click="selectQuizDelete(item)"
                              >Eliminar</CDropdownItem
                            >
                            <CDropdownItem @click="redirectToanswerTab(item.id)"
                              >ver stats</CDropdownItem
                            >
                          </CDropdown>
                        </CRow>
                      </CCardFooter>
                    </CCard>
                  </CCol>
                  <!-- </div> -->
                </CRow>
              </div>
              <div class="card-footer pb-0 pt-3">
                <jw-pagination
                  :items="itemQuiz"
                  @changePage="onChangePageitem"
                  :labels="customLabels"
                  :pageSize="12"
                ></jw-pagination>
              </div>
            </CCard>
          </div>
        </CCardBody>
      </CCard>
    </div>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import store from "../../store";
import Multiselect from "vue-multiselect";
import { SemipolarSpinner } from "epic-spinners";
import ModalCreateQuiz from "../notifications/ModalCreateQuiz";
import ModalEditQuiz from "../notifications/ModalEditQuiz";
import EditQuiz from "./EditQuiz";
import Constant from "../../config/const";
import backgroundUrl from "../../../public/img/Apache_logo.png";

import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle,
} from "mdbvue";

const customLabels = {
  first: "<<",
  last: ">>",
  previous: "<",
  next: ">",
};

export default {
  name: "table-partners",
  inheritAttrs: false,
  components: {
    mdbContainer,
    SemipolarSpinner,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput,
    Multiselect,
    ModalCreateQuiz,
    ModalEditQuiz,
    mdbDropdown,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbDropdownToggle,
  },
  props: {
    caption: {
      type: String,
      default: "Table",
    },
    hover: {
      type: Boolean,
      default: false,
    },
    striped: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: [Array, Function],
      default: () => [],
    },
    fields: {
      type: [Array, Object],
      default: () => [],
    },
    perPage: {
      type: Number,
      default: 5,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      itemQuiz: [],
      itemQuizPartner: [],
      backgroundUrl,
      pageOfItems: [],
      customLabels,
      image: { url: "img/avatars/1.jpg" },
      type_show: "card",
      currentPage: 1,
      modalCreate: false,
      modal: false,
      isLoadingLine: false,
      isLoading: false,
      isLoading_quiz: false,
      modalName: "",
      confirmar: false,
      sendFtp: false,
      quizSelected: {},
      searchDropdownName: [],
      searchDropdownPartner_id: [],
      searchDropdownDate: [],
      temp_Quiz: [],
      selectedPartnerId: "",
      selectedName: "",
      partners: [],
      selectedSurveys: [],
      selectedDate: "",
      surveys: [],
      surveys_temp: [],
      partner_ids: [],
      quiz_ids: [],
      partnerFilter: [],
      range: [],
      imagesByQuiz: [],
      comenzados: [],
    };
  },
  computed: {
    items: function () {
      const items = this.tableData;
      this.itemQuiz = this.surveys;
      // this.surveys = this.tableData;
      // this.itemQuizPartner = this.tableData;
      this.temp_Quiz = this.surveys;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function () {
      return this.getRowCount();
    },
    captions: function () {
      return this.fields;
    },
  },
  async mounted() {
    var respuesta = await this.getPartners();
    // await this.getQuizes();
    await this.getcommenzadosCount();
  },
  methods: {
    async getPartners() {
      var partners = store.getters.getPartners;
      if (partners.length == 0) {
        this.isLoading = true;
        await store.dispatch("getPartnersQuiz").then(() => {
          partners = store.getters.getPartnersQuiz;
          this.partners = partners;
          this.partnersArray = partners;

          return;
        });
      } else {
        this.partners = partners;
        this.partnersArray = partners;

        //console.log("partners ::::::::: ",partners);
        return;
      }
      this.isLoading = false;
    },
    async getQuizes() {
      // var location_ids = this.locationSelected;
      var partner_ids = [];
      var surveys = [];
      var create_date = [];

      partner_ids = this.partner_ids;
      // surveys = this.selectedSurveys;
      var payload = {
        partner_ids: partner_ids,
        quiz_ids: surveys,
        create_date: create_date,
      };

      //console.log("payload in view ::: ", payload);
      this.isLoading_quiz = true;
      var quiz_ids = [];
      var image_ids = [];

      await store.dispatch("getQuizes", payload).then(() => {
        var quizes_data = store.getters.getQuizes;
        //console.log("quizes_data::: ", quizes_data);
        var count = 0;
        quizes_data.forEach((data) => {
          quiz_ids.push(data.id);
          image_ids.push(data.title_img[0]);
        });
        //console.log("=============?", image_ids, quiz_ids);
        this.quiz_ids = quiz_ids;

        if (quizes_data.length > 0) {
          // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
          // this.getreview_CountMonth(avgstarratingpermonth_location);
          this.surveys = quizes_data;
          this.surveys_temp = quizes_data;
          //console.log("this.surveys ::: ", this.surveys, quizes_data.length);
          // this.items = quizes_data;
        } else {
          this.surveys = [];
          this.items = [];
          this.quiz_ids = [];
        }
        this.isLoading_quiz = false;
        return;
      });
      //console.log("Quiz_ids in get quiz ::: ", quiz_ids);
      await this.getImagebyQuiz(image_ids);
      await this.getcommenzadosCount();
    },

    async getQuizesbyQuizid() {
      // var location_ids = this.locationSelected;
      var partner_ids = [];
      var surveys = [];
      var create_date = [];

      partner_ids = this.partner_ids;
      surveys = this.selectedSurveys;
      var payload = {
        partner_ids: partner_ids,
        quiz_ids: surveys,
        create_date: create_date,
      };

      //console.log("payload in view ::: ", payload);
      var quiz_ids = [];
      var image_ids = [];
      await store.dispatch("getQuizes", payload).then(() => {
        var quizes_data = store.getters.getQuizes;
        //console.log("quizes_data::: ", quizes_data);
        var count = 0;
        quizes_data.forEach((data) => {
          quiz_ids.push(data.id);
          image_ids.push(data.title_img[0]);
        });
        //console.log("============>", quiz_ids, image_ids);
        this.quiz_ids = quiz_ids;

        if (quizes_data.length > 0) {
          // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
          // this.getreview_CountMonth(avgstarratingpermonth_location);
          this.surveys = quizes_data;
          // this.surveys_temp=quizes_data;
          //console.log("this.surveys ::: ", this.surveys, quizes_data.length);
          // this.items = quizes_data;
        } else {
          this.surveys = [];
          this.items = [];
        }
        return;
      });
      await this.getImagebyQuiz(image_ids);
      await this.getcommenzadosCount();
    },

    async getImagebyQuiz(quiz_ids) {
      // var quiz_id = this.$route.params.itemID;
      //console.log("quiz_ids", quiz_ids);
      var image_url = "";
      if (quiz_ids.length > 0) {
        await store.dispatch("getImagebyQuiz", quiz_ids).then(() => {
          var imagebyQuizData = store.getters.getImagebyQuiz;
          //console.log("imagebyQuizData::: ", imagebyQuizData);
          this.imagesByQuiz = imagebyQuizData;
          // console.log("this.imagesByQuiz :: ", this.imagesByQuiz);
          // if(imagebyQuizData.length>0){
          //   image_url = imagebyQuizData[0].image_url
          // }
        });
        // await this.getimage();
      }
      // return image_url;
    },
    getimage(quiz_id) {
      //console.log("info-", "imagesByQuiz", this.imagesByQuiz, quiz_id);
      var image_url = "";
      if (this.imagesByQuiz.length > 0) {
        this.imagesByQuiz.forEach((data) => {
          //console.log("quiz_id :::: ", quiz_id, this.imagesByQuiz, quiz_id, image_url);
          if (quiz_id === data.id) {
            image_url = data.image_url;
          }
        });

        return image_url;
      }
    },
    getcomments(quiz_id) {
      var count = 0;
      this.comenzados.forEach((data) => {
        if (quiz_id == data.quiz_id[0]) {
          count = data.__count;
        }
      });
      //console.log("quiz_id", quiz_id, this.comenzados);
      return count;
    },

    async getcommenzadosCount() {
      // var quiz_id = 1;
      // if(quiz_id !== ""){
      await store.dispatch("getcommenzadosCount").then(() => {
        var commenzadosCount = store.getters.getcommenzadosCount;
        //console.log("commenzadosCount::: ", commenzadosCount);
        var count = "0";
        //console.log("count in commenzados", count);
        this.comenzados = commenzadosCount;
        // return count;
      });
      // }
    },

    async getQuizes12() {
      var array_search = [];
      // var searchDropdown = store.getters.getQuizes;

      // console.log("this.searchDropdown 1", searchDropdown);
      // if (searchDropdown.length == 0) {
      await store.dispatch("getQuizes").then(() => {
        var searchDropdown = store.getters.getQuizes;
        this.searchDropdown = searchDropdown;
        this.searchDropdown.forEach((i) => {
          if (i.partner_id != false && i.partner_id.name != undefined) {
            if (!this.partnerFilter.includes(i.partner_id.name)) {
              this.partnerFilter.push(i.partner_id ? i.partner_id.name : "");
            }
          }
          if (!this.searchDropdownDate.includes(i.create_date)) {
            this.searchDropdownDate.push(i.create_date);
          }
        });
        return;
      });
      // } else {
      //   shuffleArray([searchDropdown]);

      //   this.searchDropdown = searchDropdown;
      //   this.searchDropdown.forEach((i) => {
      //     if (i.partner_id != false && i.partner_id.name != undefined) {
      //       if (!this.partnerFilter.includes(i.partner_id.name)) {
      //         this.partnerFilter.push(i.partner_id ? i.partner_id.name : "");
      //       }
      //     }

      //     if (!this.searchDropdownDate.includes(i.create_date)) {
      //       this.searchDropdownDate.push(i.create_date);
      //     }
      //   });
      //   return;
      // }
    },
    onChangePartnerId() {
      var disp = this.selectedPartnerId;
      this.itemQuiz = this.temp_Quiz;
      var abc = [];
      var data = this.itemQuiz;
      this.searchDropdownName = [];
      this.selectedName = "";
      if (this.selectedPartnerId == null) {
        this.itemQuiz = this.temp_Quiz;
        this.itemQuizPartner = [];
      } else {
        data.forEach((i) => {
          if (i.partner_id.name == disp) {
            abc.push(i);
            if (!this.searchDropdownName.includes(i.slug2)) {
              this.searchDropdownName.push(i.slug2);
            }
          }
        });

        this.itemQuiz = abc;
        this.itemQuizPartner = abc;
      }
    },

    getSortedquiz(sortdata) {
      var itemQuiz = this.itemQuiz;

      var filtered_reviews = [];
      if (sortdata === "createDateAsc") {
        itemQuiz.sort(function (a, b) {
          var b_date = new Date(b.create_date).getTime();
          var a_date = new Date(a.create_date).getTime();
          var c = a_date - b_date;
          // console.lgo
          return c;
        });

        this.itemQuiz = itemQuiz;
      }
      if (sortdata === "createDateDesc") {
        itemQuiz.sort(function (a, b) {
          var b_date = new Date(b.create_date).getTime();
          var a_date = new Date(a.create_date).getTime();
          var c = b_date - a_date;
          return c;
        });

        this.itemQuiz = itemQuiz;
      }
      if (sortdata === "stat_idAsc") {
        var itemQuiz_sorted = _.sortBy(itemQuiz, "stat_ids.length");

        this.itemQuiz = itemQuiz_sorted;
      }
      if (sortdata === "stat_idDesc") {
        var itemQuiz_sorted = _.sortBy(itemQuiz, "stat_ids.length").reverse();

        this.itemQuiz = itemQuiz_sorted;
      }
    },
    onChangeName() {
      //console.log("this.selectedName", this.selectedName);
      this.selectedSurveys = [];
      if (this.selectedName !== null)
        this.selectedSurveys.push(this.selectedName.id);

      this.getQuizesbyQuizid();
    },
    onChangeName12() {
      var disp = this.selectedName;
      // console.log("this.selectedName ::: ",disp, this.selectedName);
      if (disp == null) {
        this.itemQuiz = this.itemQuizPartner;
      }
      if (!disp == null || !disp == "") {
        var abc = [];
        var data = this.itemQuizPartner;
        data.forEach((i) => {
          if (i.slug2 == disp) {
            abc.push(i);
          }
        });
        // console.log("abc :::: ", abc.length);
        this.itemQuiz = abc;
      }
      if (!this.selectedPartnerId == null) {
        this.itemQuiz = this.itemQuizPartner;
      }
    },
    onChangeDateSearch() {
      var disp = this.selectedDate;
      // console.log(disp);
      this.itemQuiz = this.temp_Quiz;
      var abc = [];
      var data = this.itemQuiz;
      data.forEach((i) => {
        if (i.create_date == disp) {
          abc.push(i);
        }
      });
      this.itemQuiz = abc;
    },
    onChangePageitem(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    getRowCount: function () {
      console.log("this.items ::: ", this.items);
      return this.items.length;
    },
    isTrueSelect(acciones) {
      if (acciones) {
        return true;
      }
      return false;
    },
    selectQuizEdit(item, items) {
      this.quizSelected = item;
      this.modalName = "Editar";
      this.modal = true;
    },
    redirectToCreatePage(item) {
      // this.$router.push({ path: `/createquiz/${item}` });
      this.$router.push({ path: `/createquiz/${item}` });
    },
    redirectToEditPage(item) {
      // this.$router.push({ path: `/createquiz/${item}` });
      this.$router.push({ path: `/editquiz/`, params: { webSite: `${item}` } });
    },
    redirectToanswerTab(item) {
      this.$router.push({ path: `/answer/${item}` });
    },
    selectQuizDelete(item) {
      this.quizSelected = item;
      this.modalName = "Eliminar";
      this.confirmar = true;
    },
    openModal(etapa) {
      console.log("etapa", etapa);
      this.modalName = etapa;
      this.modal = true;
    },
    closeModalCreate() {
      this.modal = false;
    },
    publicarFtp(id) {
      store
        .dispatch("getBotonActionResponse", {
          model: "apache.quiz",
          method: "public_quiz",
          id,
        })
        .then(() => {
          var boton_action_response = store.getters.getBotonActionResponse;
          if (boton_action_response.target === "_blank") {
            window.open(Constant.api_path + boton_action_response.url);
          } else {
            this.sendFtp = true;
            //window.location(Constant.api_path+boton_action_response.url)
          }
        });
    },
    quizPreview(id) {
      store
        .dispatch("getBotonActionResponse", {
          model: "apache.quiz",
          method: "quiz_preview",
          id,
        })
        .then(() => {
          var boton_action_response = store.getters.getBotonActionResponse;
          //console.log("Constant.api_path + boton_action_response.url ::: ", Constant.api_path, boton_action_response.url, boton_action_response.target);

          if (boton_action_response.target === "_blank") {
            window.open(Constant.api_path + boton_action_response.url);
          } else {
            window.location(Constant.api_path + boton_action_response.url);
          }
        });
      this.confirmar = false;
    },
    eliminar() {
      console.log("this.quizSelected.id ::: ", this.quizSelected);
      setTimeout(() => {
        store.dispatch("deleteQuizUtility", this.quizSelected.id);
      }, 400);
      store.dispatch("deleteQuiz", this.quizSelected.id);
      this.confirmar = false;
    },
    changeView(type) {
      this.type_show = type;
    },
  },
  watch: {
    // selectedPartnerId: function (partnerSelected) {
    //   var partner_ids = [];
    //   console.log("partner_ids::::", partnerSelected);
    //   partnerSelected.forEach((partner) => {
    //     // if(partnerSelected !== null)

    //       // partner_ids.push(partnerSelected.id);
    //       partner_ids.push(partner.id);
    //   });
    //   this.locationSelected = [];
    //   console.log("partner_ids::::", partnerSelected, partner_ids);

    //   if (partner_ids.length > 0) {
    //     // partner_ids = partner_ids;
    //     this.partner_ids = partner_ids;
    //     this.getQuizes();

    //   } else {
    //     // this.partners=[];
    //     this.partner_ids=[];
    //     this.quizSelected={};
    //     this.surveys=[]
    //   }
    // },

    selectedPartnerId: function (partnerSelected) {
      var partner_ids = [];
      //console.log("partner_ids::::", partnerSelected);
      if (partnerSelected !== null) {
        partner_ids.push(partnerSelected.id);
      }
      // partnerSelected.forEach((partner) => {
      //     partner_ids.push(partner.id);
      // });
      this.quizSelected = [];
      //console.log("partner_ids::::", partnerSelected, partner_ids);

      if (partner_ids.length > 0) {
        // partner_ids = partner_ids;
        this.partner_ids = partner_ids;
        this.getQuizes();
        // this.getcommenzadosCount();
        // this.surveys_temp=surveys;
      } else {
        // this.partners=[];
        // this.partner_ids=[];
        this.surveys = [];
        this.quiz_ids = [];
        this.surveys_temp = [];
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.badge {
  cursor: pointer;
}
.modal-body {
  overflow-y: auto;
  height: 400px;
  padding-top: 100px !important;
}

.modal-contenedor {
  top: 50px;
}
.box {
  /* height: 175px; */
  /* width: 200px; */
  padding-left: 10px;
  padding-top: 80px;
  padding-bottom: 80px;
  background-image: url(../../../public/img/Apache_logo.png);
  background-size: cover;
  background-color: "#ced2d8";
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  /* color: blue; */
}
.card-img {
  width: 80%;
}
.partner-card {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}
@media screen and (max-width: 767px) {
  .survey-wrapper .col-sm-4 {
    padding-bottom: 10px;
  }
}
@media screen and (max-width: 1100px) {
  .partner-card {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33%;
    flex: 0 0 33%;
    max-width: 33%;
  }
}
@media screen and (max-width: 760px) {
  .partner-card {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media screen and (max-width: 550px) {
  .partner-card {
    width: 100%;
    flex: none;
    max-width: 100%;
  }
  .partner-card img.card-img {
    width: 50%;
  }
}
</style>
